<template>
    <div>
        <b-card>
            <b-tabs>
                <b-tab title="Pedido Enviado" active>
                    <b-card header-tag="header" footer-tag="footer">
                        <template v-slot:header>
                            <p class="mb-0 text-center" style="font-size: 21px">Detalle del pedido #{{pedidoLocal.id}}</p>
                        </template>
                        <b-card-text>
                            
                            <b-row>
                                <b-col class="pb-4" cols="12" md="6">
                                    <div>Realizado Por: <b>{{pedidoLocal.nombre_usuario}} </b></div>
                                    <div>Fecha: <b>{{pedidoLocal.created_at_formatted}} </b></div>
                                    <div>Sucursal: <b>{{sucursal.nombre}} </b></div>
                                    <div>Estado del pedido: <b-badge pill :variant="pedidoLocal.statusClass">{{pedidoLocal.statusLabel}}</b-badge></div>
                                    <div v-if="pedidoLocal.servicio_logistico">Servicio Logístico: <b-badge variant="info">Si</b-badge></div>
                                    <div>Sucursal: <b>{{sucursal.nombre}} </b></div>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <div v-if="pedidoLocal.payment_state">Estado de Pago: <b-badge v-if="pedidoLocal.payment_state" :variant="statusClass[pedidoLocal.payment_state]">{{ statusLabel[pedidoLocal.payment_state] }}</b-badge></div>
                                    <div v-if="pedidoLocal.invoice_date_due_formatted">Fecha Limite de pago: <b>{{pedidoLocal.invoice_date_due_formatted}} </b> </div>
                                    <div v-if="pedidoLocal.sale_order_supplier_id">Orden de venta: <b>{{pedidoLocal.sale_order_supplier_id}} </b> </div>
                                    <div v-if="pedidoLocal.bill_supplier_id">Factura:  <b>{{pedidoLocal.bill_supplier_id}} </b> </div>
                                    <div v-if="pedidoLocal.supplier_bill_amount">Monto Factura:  <b> $ {{ numberFormat(pedidoLocal.supplier_bill_amount) }} </b></div>
                                    <div v-if="pedidoLocal.bill_supplier_date_formatted">Fecha Factura:  <b> {{ pedidoLocal.bill_supplier_date_formatted }} </b></div>
                                    <div v-if="pedidoLocal.credit_note_supplier_id">Nota Crédito:  <b>{{pedidoLocal.credit_note_supplier_id}} </b></div>
                                    <div v-if="pedidoLocal.supplier_credit_note_amount">Monto Nota Crédito:  <b> $ {{ numberFormat(pedidoLocal.supplier_credit_note_amount) }} </b></div>
                                </b-col>
                            </b-row>
                            
                        </b-card-text>
                        <ItemsComponent :items="pedidoLocalItems" :descuento="true" />
                        <ItemsFooter :data="pedidoLocal" />
                    </b-card>
                </b-tab>
                <b-tab title="Procesado por asesor" v-if="showLiquidacionAsesor">
                    <b-card header-tag="header" footer-tag="footer">
                        <template v-slot:header>
                            <p class="mb-0 text-center" style="font-size: 21px">Detalle del pedido #{{liquidacionAsesor.identificador}}</p>
                        </template>
                        <b-card-text>
                            <div><b>Realizado Por:</b> {{liquidacionAsesor.nombre_asesor}}</div>
                            <div><b>Referencia Asesor:</b> {{liquidacionAsesor.referencia_asesor}}</div>
                            <div><b>Correo:</b> {{liquidacionAsesor.email_asesor}}</div>
                            <div><b>Telefono:</b> {{liquidacionAsesor.telefono_asesor}}</div>
                            <div><b>Fecha:</b> {{liquidacionAsesor.fecha}}</div>
                            <div><b>Estado del pedido: <b-badge pill :variant="pedidoLocal.statusClass">{{pedidoLocal.statusLabel}}</b-badge></b></div>
                        </b-card-text>
                        <ItemsComponent :items="liquidacionAsesorItems"/>
                        <ItemsFooter :data="liquidacionAsesor" />
                    </b-card>
                </b-tab>
                <b-tab title="Liquidación" v-if="showLiquidacion">
                    <b-card header-tag="header" footer-tag="footer">
                        <template v-slot:header>
                            <p class="mb-0 text-center" style="font-size: 21px">Detalle del pedido #{{liquidacion.identificador}}</p>
                        </template>
                        <b-card-text>
                            <div><b>Realizado Por:</b> {{liquidacionAsesor.nombre_asesor}}</div>
                            <div><b>Referencia Asesor:</b> {{liquidacionAsesor.referencia_asesor}}</div>
                            <div><b>Correo:</b> {{liquidacionAsesor.email_asesor}}</div>
                            <div><b>Telefono:</b> {{liquidacionAsesor.telefono_asesor}}</div>
                            <div><b>Fecha:</b> {{liquidacionAsesor.fecha}}</div>
                            <div><b>Estado del pedido: <b-badge pill :variant="pedidoLocal.statusClass">{{pedidoLocal.statusLabel}}</b-badge></b></div>
                        </b-card-text>
                        <ItemsComponent :items="liquidacionItems"/>
                        <ItemsFooter :data="liquidacion" />
                    </b-card>
                </b-tab>
            </b-tabs>
            <template v-slot:footer>
                <template v-if="user.includes('orders_prov_supervisor')">
                    <b-button id="volver" variant="danger" 
                        class="text-white mr-2" 
                        @click.prevent="back">
                        Volver Listado
                    </b-button>
                    <template v-if="pedidoLocal.status == 0">
                        <b-button id="volver" variant="danger" 
                            class="text-white mr-2" 
                            @click.prevent="descartarPedido = true">
                            Descartar
                        </b-button>
                    </template>
                    <template v-if="pedidoLocal.status == 0">
                        <b-button id="volver" variant="success" 
                            class="text-white mr-2" 
                            @click.prevent="aprobarPedido = true">
                            Aprobar
                        </b-button>
                    </template>
                    <b-button variant="info" 
                        class="text-white mr-2" 
                        @click.prevent="printWindow()">
                        Imprimir
                    </b-button>
                </template>
                <template v-else>
                    <b-button id="volver" variant="danger" 
                        class="text-white mr-2" 
                        @click.prevent="back">
                        Volver Listado
                    </b-button>
                    <b-button variant="info" 
                        class="text-white mr-2" 
                        @click.prevent="printWindow()">
                        Imprimir
                    </b-button>
                </template>
            </template>
        </b-card>
    
        <!--confirmar solicitud de pedido -->
        <confirm-modal 
            :openModal="aprobarPedido" 
            title="Confirmar Aprobacion"
            message="¿En realidad desea confirmar el pedido?"
            @close-modal="aprobarPedido = false"
            @confirm-modal="confirmPedido()"
        />
        <!--descartar solicitud de pedido -->
        <confirm-modal 
            :openModal="descartarPedido" 
            title="Confirmar Cancelación"
            message="¿En realidad desea descartar el pedido?"
            @close-modal="descartarPedido = false"
            @confirm-modal="cancelPedido()"
        />
    </div>
</template>
<script>
import ItemsComponent from '../components/ItemsComponent.vue'
import ItemsFooter from '../components/ItemsFooter.vue'
import ConfirmModal from '@/components/ModalConfirm.vue'
import { mapMutations } from 'vuex'
export default {
    data(){
        return{
            id: this.$route.params.id,

            pedidoLocal: {},
            sucursal: "",
            pedidoLocalItems: [],
            liquidacionAsesor: {},
            liquidacionAsesorItems: [],
            liquidacion: {},
            liquidacionItems: [],
            showLiquidacionAsesor : false,
            showLiquidacion : false,
            user: "",
            aprobarPedido: false,
            descartarPedido: false,
            supervisor: false,
            statusLabel: {
                not_paid: "Sin pagar",
                in_payment: "En proceso de pago pago",
                paid: "Pagado",
                partial : "Pagado parcialmente",
                reversed: "Revertido",
            },
            statusClass: {
                not_paid: "danger",
                in_payment: "warning",
                paid: "success",
                partial : "warning",
                reversed: "success",
            }
        }
    },
    components: {
        ItemsComponent,
        ItemsFooter,
        ConfirmModal
    },
    created(){
       this.getPedidoDescription();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getPedidoDescription(){
            this.setLoading(true)
            await this.$conectar.post('pedidos/proveedor/get-pedido-description', {id: this.id})
            .then(response =>{
                this.pedidoLocal = response.data.pedidoLocal;
                this.sucursal = response.data.pedidoLocal.sucursal_data;
                this.pedidoLocalItems = response.data.pedidoLocal.items;
                if(response.data.liquidacionAsesor !== null){
                    this.liquidacionAsesor = response.data.liquidacionAsesor;
                    this.liquidacionAsesorItems = response.data.liquidacionAsesor.items;
                    this.showLiquidacionAsesor = true;
                }
                if(response.data.liquidacion !== null){
                    this.liquidacion = response.data.liquidacion;
                    this.liquidacionItems = response.data.liquidacion.items;
                    this.showLiquidacion = true;
                }
                this.user = localStorage.getItem('user_permissions');

            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async confirmPedido(){
            let status = 2;
            this.aprobarPedido = false;
            this.setLoading(true)
            await this.$conectar.post('pedidos/proveedor/update-pedido-proveedor-status', {id: this.id, status: status})
            .then(response => {
                if(response.data.error == false){
                    this.getPedidoDescription();
                }else{
                    this.$bvToast.toast(response.data.mensaje, {
                        title: "Error al actualizar la solicitud",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast("Parece que hubo un error al conectar con el servidor", {
                    title: "Error al actualizar la solicitud",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        async cancelPedido(){
            let status = 1;
            this.descartarPedido = false;
            this.setLoading(true)
            await this.$conectar.post('pedidos/proveedor/update-pedido-proveedor-status', {id: this.id, status: status})
            .then(response => {
                if(response.data.error == false){
                    this.getPedidoDescription();
                }else{
                    this.$bvToast.toast(response.data.mensaje, {
                        title: "Error al actualizar la solicitud",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast("Parece que hubo un error al conectar con el servidor", {
                    title: "Error al actualizar la solicitud",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        back(){
            this.$router.go(-1);
        },
        printWindow() {
            window.print();
        }

    }
}
</script>
<style scoped>
.widthPersonalized{
    max-width: 400px;
}
.precio{
    min-width: 600px;
}

.singleLine th {
  white-space: nowrap !important;
  overflow: hidden !important;
}

.singleLines {
  white-space: nowrap !important;
  overflow: hidden !important;
}

@media print {
  button {
    display: none;
  }
  #volver{
    display: none;
  }
}


</style>